import { SILK_COLOURS } from "../lib/constants";
import { Star } from "lucide-react";

export default function HorseRow({ horse, picked, staged, locked, onPick, testIdBase }) {
  const scratched = horse.scratched;
  const silk = SILK_COLOURS[(horse.horse_number - 1) % SILK_COLOURS.length];

  let bg = "bg-white border-[#e9ecef]";
  let opacity = "";
  if (picked && locked) bg = "bg-[#1971c2]/10 border-[#1971c2]";
  else if (picked && staged) bg = "bg-[#6741d9]/10 border-[#6741d9]";
  else if (picked) bg = "bg-[#1971c2]/10 border-[#1971c2]";
  if (scratched) { bg = "bg-[#f8f9fa] border-[#e9ecef]"; opacity = "opacity-60"; }

  return (
    <button
      onClick={onPick}
      disabled={scratched || locked}
      data-testid={`${testIdBase}-horse-${horse.horse_number}`}
      className={`w-full flex items-center gap-3 p-3 border rounded-xl transition-transform active:scale-[0.98] ${bg} ${opacity} ${scratched || locked ? "cursor-default" : "hover:border-[#1971c2] cursor-pointer"} text-left`}
    >
      <div
        className="w-9 h-9 rounded-md shrink-0 flex items-center justify-center text-white font-black text-sm"
        style={{ backgroundColor: silk, boxShadow: "inset 0 0 0 2px rgba(255,255,255,0.35)" }}
      >
        {horse.horse_number}
      </div>
      <div className="min-w-0 flex-1">
        <div className="flex items-center gap-1.5 flex-wrap">
          <span className={`font-display font-extrabold text-sm truncate ${scratched ? "line-through" : ""}`}>
            {horse.name}
          </span>
          {horse.is_favourite && !scratched && (
            <span className="inline-flex items-center gap-0.5 text-[9px] font-black uppercase tracking-wider bg-[#0c8599]/10 text-[#0c8599] border border-[#0c8599]/25 rounded-full px-1.5 py-0.5">
              <Star className="w-3 h-3 fill-[#0c8599] text-[#0c8599]" strokeWidth={2.5} /> FAV
            </span>
          )}
          {scratched && (
            <span className="text-[9px] font-black uppercase tracking-wider bg-[#c92a2a]/10 text-[#c92a2a] border border-[#c92a2a]/25 rounded-full px-1.5 py-0.5">
              SCRATCHED
            </span>
          )}
        </div>
        <div className="text-[11px] text-[#6c757d] mt-0.5 truncate">
          Bar {horse.barrier} · {horse.jockey} · {horse.trainer}
        </div>
      </div>
      <div className="text-right shrink-0">
        <div className="font-display font-black text-lg text-[#212529] tabular-nums">
          {horse.odds.toFixed(2)}
        </div>
        {picked && staged && (
          <div className="text-[9px] font-black uppercase tracking-wider bg-[#6741d9] text-white rounded-full px-1.5 py-0.5 mt-0.5" data-testid={`${testIdBase}-pending-pill`}>
            Pending
          </div>
        )}
        {picked && !staged && (
          <div className={`text-[9px] font-black uppercase tracking-wider text-white rounded-full px-1.5 py-0.5 mt-0.5 ${locked ? "bg-[#495057]" : "bg-[#1971c2]"}`} data-testid={locked ? `${testIdBase}-locked-pill` : `${testIdBase}-confirmed-pill`}>
            {locked ? "Locked" : "Confirmed"}
          </div>
        )}
      </div>
    </button>
  );
}
